<template>
  <div>
  <v-row no-gutters class="mt-4">
    <v-col cols="12" sm="auto" v-if="hasVotePermision">
      <v-row no-gutters >
        <v-item-group
          class="v-btn-toggle vote-class mr-4"
          :value="approvalStatus"
          :class="!isMeetingDataSaved ? 'disable-events' : ''"
        >
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <a-btn
                :class="approvalStatus === 0 ? 'active-vote-class' : ''"
                v-bind="attrs"
                v-on="on"
                :disabled="!isMeetingDataSaved"
                :value="0"
                @click="onApprovalStatusChange($event, 0)"
              >
                <span class="hidden-sm-and-down">{{
                  $t("agenda.btnApproval") 
                }} </span>
              </a-btn>
            </template>
            <span>{{ $t("agenda.tipApproval") }}</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <a-btn
                :class="approvalStatus === 1 ? 'active-vote-class' : ''"
                v-bind="attrs"
                v-on="on"
                :disabled="!isMeetingDataSaved"
                :value="1"
                @click="onApprovalStatusChange($event, 1)"
              >
                <span class="hidden-sm-and-down">{{
                  $t("agenda.btnReject")
                }}</span>
              </a-btn>
            </template>
            <span>{{ $t("agenda.tipReject") }}</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <a-btn
                :class="approvalStatus === 2 ? 'active-vote-class' : ''"
                v-bind="attrs"
                v-on="on"
                :disabled="!isMeetingDataSaved"
                :value="2"
                @click="onApprovalStatusChange($event, 2)"
              >
                <span class="hidden-sm-and-down">{{
                  $t("agenda.btnAbstain")
                }}</span>
              </a-btn>
            </template>
            <span>{{ $t("agenda.tipAbstain") }}</span>
          </v-tooltip>
        </v-item-group>
      </v-row>
    </v-col>
    <v-col cols="12" sm="auto" v-if="isAuditorsConsent">
      <v-row no-gutters class="mr-4">
        <v-item-group
          class="v-btn-toggle vote-class"
          :value="consentStatus"
          :class="!isMeetingDataSaved ? 'disable-events' : ''"
        >
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <a-btn
                :class="consentStatus === 0 ? 'active-vote-class' : ''"
                v-bind="attrs"
                v-on="on"
                :disabled="!isMeetingDataSaved"
                :value="0"
                @click="onObjectionStatusChange($event, 0)"
              >
                <span class="hidden-sm-and-down">{{
                  $t("agenda.btnNoObjection")
                }}</span>
              </a-btn>
            </template>
            <span>{{ $t("agenda.btnNoObjection") }}</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <a-btn
                :class="consentStatus === 1 ? 'active-vote-class' : ''"
                v-bind="attrs"
                v-on="on"
                :disabled="!isMeetingDataSaved"
                :value="1"
                @click="onObjectionStatusChange($event, 1)"
              >
                <span class="hidden-sm-and-down">{{
                  $t("agenda.btnHasObjection")
                }}</span>
              </a-btn>
            </template>
            <span>{{ $t("agenda.btnHasObjection") }}</span>
          </v-tooltip>
        </v-item-group>
      </v-row>
    </v-col>
    <v-col cols="12" sm="auto">
      <approval-result
        :topicApproval="topicAppoval"
        :agendaName="agendaName"
        :topicName="topicName"
        :meetingObj="meetingObj"
        :topicId="topicId"
      ></approval-result>
    </v-col>
  </v-row>
  <v-row no-gutters class="mt-4">
 <v-col cols="12" sm="auto">
      <v-tooltip bottom v-if="isOpen">
        <template v-slot:activator="{ on, attrs }">
          <a-chip
            v-bind="attrs"
            v-on="on"
            outlined
            color="primary"
            class="opened"
            >{{ $t("agenda.btnOpened") }}</a-chip
          >
        </template>
        <span>{{ $t("agenda.tipAcceptanceOpened") }}</span>
      </v-tooltip>
      <v-tooltip bottom v-else>
        <template v-slot:activator="{ on, attrs }">
          <a-chip v-bind="attrs" v-on="on" outlined class="minute">{{
            $t("agenda.btnClosed")
          }}</a-chip>
        </template>
        <span>{{ $t("agenda.tipAcceptanceClosed") }}</span>
      </v-tooltip>
      <v-item-group
        v-if="updateMeetingPermission"
        class="v-btn-toggle vote-class ml-4"
        :value="isOpen"
      >
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <a-btn
              :class="isOpen ? 'active-vote-class' : ''"
              v-bind="attrs"
              v-on="on"
              :value="true"
              @click="onVotingOptionChange($event, true)"
            >
              <span class="hidden-sm-and-down">{{ $t("agenda.btnOpen") }}</span>
            </a-btn>
          </template>
          <span>{{ $t("agenda.tipStartAcceptance") }}</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <a-btn
              :class="!isOpen ? 'active-vote-class' : ''"
              v-bind="attrs"
              v-on="on"
              :value="false"
              @click="onVotingOptionChange($event, false)"
            >
              <span class="hidden-sm-and-down">{{ $t("btnClose") }}</span>
            </a-btn>
          </template>
          <span>{{ $t("agenda.tipCloseAcceptance") }}</span>
        </v-tooltip>
      </v-item-group>
    </v-col>
    <v-col cols="12" sm="auto" class="primary--text pl-2 align-content-center">
    <approval-status v-if="updateMeetingPermission" :topicData="topicData" :meetingObj="meetingObj" :isAuditorsConsent="isMeetingAuditorsConsent"></approval-status>
    </v-col>
  </v-row>
    <confirm-dialog ref="confirm"></confirm-dialog>
    <voting-confirmation-dialog
      v-if="showVotingConfirmationDialog"
      v-model="showVotingConfirmationDialog"
      @change="onVotingChange"
      :votingLabel="selectedVotingOptionLabel"
      :type="votingType"
      :comment="selectedComment"
      @cancel="onVotingCancel"
    ></voting-confirmation-dialog>
    <MessageSheet
      :showMessage="displayMessage"
      :message="message"
      :messageType="messageType"
      @close="displayMessage = false"
    ></MessageSheet>
  </v-row>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import ConfirmDialog from "../ConfirmDialog.vue";
import ApprovalResult from "./approvalResult.vue";
import MessageSheet from "@/components/MessageSheet.vue";
import VotingConfirmationDialog from "./VotingConfirmationDialog.vue";
import ApprovalStatus from "./ApprovalStatus.vue";
const voatingStatus = {
  0: "approve",
  1: "reject",
  2: "abstain",
  "": "",
};
const auditorConsents = {
  0: "noObjection",
  1: "hasObjection",
  "": "",
};

export default {
  name: "ApprovalControl",
  components: {
    ApprovalResult,
    ConfirmDialog,
    MessageSheet,
    VotingConfirmationDialog,
    ApprovalStatus
  },
  data() {
    return {
      votingType: "",
      selectedVotingOptionLabel: "",
      showVotingConfirmationDialog: false,
      message: "",
      messageType: "",
      displayMessage: false,
      isMeetingSaved: true,
      status: null,
      votingData: null,
      objection: null,
      votes: null,
      consents: null,
      votingComment: null,
      consentComment: null,
      selectedComment: ''
    };
  },
  props: {
    voteData: {
      type: Object,
      default: null,
    },
    value: {
      type: Object,
      default: () => ({
        isOpen: true,
        approvalStatusList: [],
      }),
    },
    isAttendee: {
      type: Boolean,
      default: false,
    },
    agendaName: {
      type: String,
      default: "",
    },
    topicName: {
      type: String,
      default: false,
    },
    meetingObj: {
      type: Object,
      default: null,
    },
    topicData: {
      type: Object,
      default: null,
    },
    topicId: {
      type: String,
      default: "",
    },
    isMeetingModified: Boolean,
  },
  mounted() {
    this.votingData = this.voteData;
  },
  watch: {
    showVotingConfirmationDialog(data) {
      this.$eventHub.$emit("isSilentSignalR", data);
    },
  },
  computed: {
    ...mapGetters({
      getMeetingTypeId: "meeting/getMeetingTypeId",
    }),
    LoaderText() {
      return this.$t("LoaderText");
    },
    selectedTenant() {
      return sessionStorage.getItem("tenantId");
    },
    tenantName() {
      const users = this.$auth.user[process.env.VUE_APP_TENANT_KEY];
      const tenant = users.find((u) => u.id === this.selectedTenant);
      if (tenant) {
        return tenant.name;
      }
      return "";
    },
    isPermittedAttendee(){
      if(!this.meetingObj.attendees){
        return false;
      }
      return this.meetingObj.attendees.some(
        (user) => user.email === this.$auth.user.email.toLowerCase().trim() && user.is_authorized
      );

    },
    topicAppoval: {
      get() {
        return this.value;
      },
      set(val) {
        this.value = val;
        this.$emit("input", val);
      },
    },
    isOpen() {
      return Boolean(this.topicAppoval.isOpen);
    },
    consentStatus() {
      if (this.voteData) {
        this.objection = this.voteData.consentStatus;
        this.consentComment = this.voteData.consentComment || null;
        switch (this.objection) {
          case "noObjection":
            return 0;
          case "hasObjection":
            return 1;
          default:
            return "";
        }
      }
      return "";
    },
    approvalStatus() {
      if (this.voteData) {
        this.status = this.voteData.approvalStatus;
        this.votingComment = this.voteData.votingComment || null;
        switch (this.status) {
          case "approve":
            return 0;
          case "reject":
            return 1;
          case "abstain":
            return 2;
          default:
            return "";
        }
      }

      return "";
    },
    isAuditorsConsent() {
      // return this.isAttendee && this.meetingObj.resolutionType === "In Writing";
      return (
        this.isAttendee &&
        this.meetingObj.resolutionType === "In Writing" &&
        this.auditorConsentPermission
      );
    },
    isMeetingAuditorsConsent() {
      return this.meetingObj.resolutionType === "In Writing";
    },
    hasVotePermision() {
      return this.isAttendee && this.votingRightPermission;
    },
    isMeetingDataSaved() {
      return (
        Boolean(this.isOpen) && this.isMeetingSaved && !this.isMeetingModified
      );
    },
    cnfMessage() {
      return this.$t("agenda.votingStatusConfirmationMessage", {
        isOpen: this.isOpen ? this.$t("lblClose") : this.$t("lblOpen"),
      });
    },
    updateMeetingPermission() {
      if (this.getMeetingTypeId) {
        return this.$security.checkMeetingTypeAccess(
          this.getMeetingTypeId,
          "UpdateMeeting"
        );
      }
      return false;
    },
    auditorConsentPermission() {
      if (this.getMeetingTypeId) {
        return this.$security.checkMeetingTypeAccess(
          this.getMeetingTypeId,
          "AuditorConsent"
        );
      }
      return false;
    },
    votingRightPermission() {
      if (this.getMeetingTypeId) {
        return this.$security.checkMeetingTypeAccess(
          this.getMeetingTypeId,
          "VotingRight"
        );
      }
      return false;
    },
  },

  methods: {
    ...mapActions({
      updateMeetingTopicVote: "meeting/updateMeetingTopicVote",
    }),
    textColorStyle(btnIndex) {
      if (this.approvalStatus !== btnIndex && this.isMeetingDataSaved) {
        return "color:var(--v-primary-darken1)";
      }

      if (this.approvalStatus !== btnIndex && !this.isMeetingDataSaved) {
        return "color:var(--v-secondary-lighten1)";
      }
      return "color:white";
    },
    showMessageSheet(message, messageType) {
      this.displayMessage = true;
      this.message = message;
      this.messageType = messageType;
    },
    async onObjectionStatusChange(e, value) {
      try {
        this.consents = auditorConsents[value];
        this.selectedVotingOptionLabel =
          value === 0
            ? this.$t("agenda.btnNoObjection")
            : this.$t("agenda.btnHasObjection");
        this.showVotingConfirmationDialog = true;
        this.votingType = "consent";

        if(this.voteData && this.voteData.consentComment && (value === this.consentStatus)){
          this.selectedComment = this.voteData.consentComment
        }else{
          this.selectedComment = ""
        }

      } catch (error) {
        console.error(error);
      }
    },
    async onApprovalStatusChange(e, val) {
      try {
        this.votes = voatingStatus[val];
        const votingLabels = {
          0: this.$t("agenda.btnApproval"),
          1: this.$t("agenda.btnReject"),
          2: this.$t("agenda.btnAbstain"),
        };

        this.selectedVotingOptionLabel = votingLabels.hasOwnProperty(val)
          ? votingLabels[val]
          : this.votes;

        this.showVotingConfirmationDialog = true;
        this.votingType = "approval";
        
        if(this.voteData && this.voteData.votingComment && (val === this.approvalStatus)){
          this.selectedComment = this.voteData.votingComment
        }else{
          this.selectedComment = ""
        }
      } catch (error) {
        console.error(error);
      }
    },
    saveMeeting() {
      this.isMeetingSaved = true;
      this.$emit("onApprovalSettingChange");
    },
    async onVotingOptionChange(e, value) {
      if (value === this.isOpen) {
        e.cancel = true;
        return;
      }
      let header = `${this.agendaName} - ${this.topicName}`;
      if (this.agendaName === this.topicName) {
        header = this.agendaName;
      }
      if (
        await this.$refs.confirm.open(header, this.cnfMessage, {
          yesNoButtons: true,
          width: 500,
        })
      ) {
        this.topicAppoval.isOpen = value;
        this.isMeetingSaved = true;
        this.$emit("onApprovalSettingChange", this.topicAppoval);
      } else {
        e.cancel = true;
        return false;
      }
    },
    async onVotingChange(comment) {

      const voteMap = {
          approve: this.$t("agenda.lblApprove"),
          reject: this.$t("agenda.btnReject"),
          abstain: this.$t("agenda.btnAbstain"),
        };

        const consentMap = {
          noObjection: this.$t("agenda.btnNoObjection"),
          hasObjection: this.$t("agenda.btnHasObjection"),
        };

        const voteLabel = voteMap[this.votes] || this.votes;
        const consentLabel = consentMap[this.consents] || this.consents;

        let emailMessage = "";
        if(this.votingType === "approval"){
          emailMessage += `<p><b>${this.$t("poll.votingEmailContent")}: </b> <br/> <br/></p>`;
        }else{
          emailMessage += `<p><b>${this.$t("poll.consentEmailContent")}: </b> <br/> <br/></p>`;
        }
        emailMessage += `<b>${this.$t("agenda.lblCompanyName")}: </b> ${this.tenantName} <br/>`;
        emailMessage += `<b>${this.$t("settingTitleMeeting")}: </b> ${this.meetingObj.meetingName} <br/>`;
        emailMessage += `<b>${this.$t("statistics.lblTopic")}: </b> ${this.topicName} <br/>`;
        emailMessage += `<b>${this.$t("agenda.lblAction")}: </b> ${this.votingType === "approval" ? voteLabel : consentLabel} <br/>`;
        emailMessage += `<b>${this.$t("poll.lblDecisionMaker")}: </b> ${this.$auth.user.name} <br/>`;
        emailMessage += `<b>${this.$t("agenda.lblEmailAddress")}: </b> ${this.$auth.user.email} <br/>`;
        const emailTemplateData = {
            template_id: process.env.VUE_APP_REMIND_VOTING_TEMPLATE_ID,
            subject: this.votingType === "approval" ? this.$t("poll.votingEmailSubject") : this.$t("poll.consentEmailSubject"),
            message: emailMessage,
            tenant: sessionStorage.getItem("tenantId"),
            emailDearRecipient: this.$t("email.emailDearRecipient", {
              username: '{USERNAME}',
            }),
            emailPreHeader: this.$t("email.emailPreHeader"),
            targetTitle: this.meetingObj.meetingName,
            targetLinkLabel: this.$t("agenda.meetingTargetLinkLabel"),
            targetLink: `${window.location.origin}/meeting/${this.meetingObj.id}/agenda/tenant/${this.selectedTenant}`,
        };

      const baseParams = {
        meetingId: this.meetingObj.id,
        topicId: this.topicId,
        votingComment: comment,
        email_data: emailTemplateData,
      };

      const approvalParams = {
        ...baseParams,
        approvalStatus: this.votes,
        consentStatus: this.consents || this.objection,
        consentComment: this.consentComment,
        voting_updated_at: new Date().toISOString(),
      };

      const consentParams = {
        ...baseParams,
        consentStatus: this.consents,
        approvalStatus: this.votes || this.status,
        votingComment: this.votingComment,
        consentComment: comment,
        consent_updated_at: new Date().toISOString(),
      };

      const params =
        this.votingType === "approval" ? approvalParams : consentParams;

      try {
        
        await this.updateMeetingTopicVote(params);

        this.$emit("onApprovalChange");
        const successMsg =
          this.votingType === "approval"
            ? this.$t("agenda.msgTopicVotingSuccess")
            : this.$t("agenda.msgConsentSuccess");
        this.showMessageSheet(successMsg, "success");
      } catch (error) {
        console.log(error);
        const failedMsg =
          this.votingType === "approval"
            ? this.$t("agenda.msgTopicVotingFailed")
            : this.$t("agenda.msgConsentFailed");
        this.showMessageSheet(failedMsg, "error");
      }
    },

    async onVotingCancel() {
      this.consents = null;
      this.votes = null;
    },
  },
};
</script>
<style scoped>
.opened:hover,
.minute:hover {
  cursor: pointer;
}
.v-tooltip {
  z-index: 10003 !important;
}
.a-toggle-button.v-btn-toggle:not(.v-btn-toggle--group) .v-btn.v-btn {
  border-color: var(--v-primaryDark-base) !important;
}

.v-btn-toggle:not(.v-btn-toggle--group) .v-btn.v-btn {
  border-color: var(--v-primaryDark-base) !important;
}

.v-btn-toggle.vote-class .active-vote-class /deep/ .v-btn__content {
  color: white !important;
}

.v-btn-toggle.vote-class /deep/ .v-btn__content {
  color: var(--v-primaryDark-base) !important;
}

.v-btn-toggle.vote-class .v-btn.v-btn--disabled.v-btn--has-bg {
  background-color: #fff !important;
}

.v-btn-toggle.vote-class:not(.v-btn-toggle--group) .v-btn.v-btn--disabled {
  border-color: #cccccc !important;
}

.v-btn-toggle.vote-class:not(.v-btn-toggle--group)
  .v-btn.v-btn--disabled.active-vote-class {
  background-color: #cccccc !important;
}

.v-btn-toggle.vote-class:not(.v-btn-toggle--group)
  .v-btn.v-btn--disabled
  /deep/
  .v-btn__content {
  color: #cccccc !important;
}

.v-btn-toggle.vote-class:not(.v-btn-toggle--group)
  .v-btn.v-btn--disabled.active-vote-class
  /deep/
  .v-btn__content {
  color: white !important;
}

.active-vote-class {
  opacity: inherit !important;
  background-color: var(--v-primaryDark2-base) !important;
}
</style>